module.exports = __webpack_public_path__ + "img/st.ffd48c1e.png";